import React from 'react'

import './InfoString.css'

import emailImg from'./imgs/email.png'
import linkedinImg from'./imgs/linkedin.png'
import twitterImg from'./imgs/twitter.png'
import ubiImg from'./imgs/ubi.png'
import moreImg from'./imgs/more.png'


export default function InfoString(props) {

    const info = props.content

    const img = props.img
    var image = ''

    if (img === 'email') {

        image = emailImg

    } else if (img === 'linkedin') {

        image = linkedinImg

    } else if (img === 'twitter') {

        image = twitterImg

    } else if (img === 'ubi') {

        image = ubiImg

    } else if (img === 'more') {

        image = moreImg

    }


    return (
        <div className="info_string_div">

            <img src={image} alt="#" className='image_info_string' />

            {props.link ? (

                <a href={props.content} className="text_info_string link_info_string" target='__blank'>{props.content}</a>

            ) : (

                <p className="text_info_string">{info}</p>

            )}

    

        </div>
    )

}